import * as React from 'react';
import {useState} from 'react';
import  Button  from '@mui/material/Button';
import OrganizationData from '../../../data/OrganizationData';
import { useSession } from '../../../context/SessionContext';
import { ApplicationList } from '../../../data/ControlledLists';
import ApplicationInformation from './ApplicationInformation';
import { Array2CSVString } from '../../../Utilities/Utilities';

 const  ApplicationEdit = ({data, onFieldChange, onSave}) => {   
    console.log("Modules Features Data: ",data);
    
    const [organization, setOrganization] = useState(data);
    const [errorMessage, setErrorMessage] = useState(false);
    const [savedMessage, setSavedMessage] = useState(false);
    const [warningFlag, setWarningFlag] = useState(false);
    const [message, setMessage] = useState("");
    
    const session = useSession();

    console.log("Application: ",organization);

    const handleFieldUpdate = (value, id) => {
        console.log("SaveApplications: ", value, id)
        const updatedDate = Date.UTC;
       
        var x = null;
        switch(id) {
            case "applications":
                x = {...organization, applications: Array2CSVString(value), updatedAt: updatedDate};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "nbOfSeats":
                x = {...organization, nbOfSeats: value, updatedAt: updatedDate};
                setOrganization(x);
                onFieldChange(x);
                break;
          
          default:
            console.log("None: ",id, value);
            break;
        }
      }

    const handleSave = (event) => {
        event.preventDefault();
        console.log("Save: ",organization);
        try{
            onSave();
            setSavedMessage(true);
            setErrorMessage(false);
            setTimeout(() => {
                setSavedMessage(false);
            }, 5000);
        } catch (error) {
            console.log("Error: ",error);
            setErrorMessage(true);
            setSavedMessage(false);
            setTimeout(() => {
                setErrorMessage(false);
            }, 5000);
        }
    }
 

    if (organization !== undefined) {
    return (
        <div>
        <form onSubmit={handleSave}>
            <div className="formInput"  Style={{margin:"10px", width:"700"}}>
                <box Style={{width:500}}>
                    <ApplicationInformation
                        data = {(organization !== undefined ? organization : OrganizationData)}
                        applicationList={ApplicationList}
                        onFieldChange={(event,value, id) => handleFieldUpdate(event, value, id)}
                    />
                    
                </box>
            <div className="formButtons" style={{width:800}} >
                    <div className="left">
                        {errorMessage && <div className="error">An error occurred</div>}
                        {savedMessage && <div className="message">Organization Applications Saved</div>}
                        {warningFlag && <div className="warning">{message}</div>}
                    </div>
                    <div className="right">
                        <Button  
                            type="submit"
                            variant="contained"
                            className="button"
                            >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </form>
        </div>
    );
    } else {
        return (<label>Loading...</label>)
    }
}

export default ApplicationEdit;